import React from 'react';

import {
  Actions as UIActions,
  Action,
  PlayArrowIcon,
  StopIcon,
  AssignmentIcon,
  EditIcon,
  DeleteIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_ACTIVATE,
  ACTION_DEACTIVATE,
  ACTION_DELETE,
  ACTION_EDIT,
  ACTION_MOVE_TO_TEST,
} from 'scenes/BusinessPartners/constants';

export const Actions = ({
  onEdit,
  onArchive,
  onRestore,
  onMoveToTest,
  onDelete,
  actions,
  isFirstVersion = false,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => {
        return (
          <UIActions limit={3}>
            <Action
              id={ACTION_ACTIVATE}
              label={'Activate'}
              icon={<PlayArrowIcon />}
              onClick={onRestore}
              disabled={isFirstVersion || !isActionAllowed(ACTION_ACTIVATE)}
            />
            <Action
              id={ACTION_DEACTIVATE}
              label={'Deactivate'}
              icon={<StopIcon />}
              onClick={onArchive}
              disabled={!isActionAllowed(ACTION_DEACTIVATE)}
            />
            <Action
              icon={<AssignmentIcon />}
              id={ACTION_MOVE_TO_TEST}
              label={'Move to In-Test'}
              onClick={onMoveToTest}
              disabled={!isActionAllowed(ACTION_MOVE_TO_TEST)}
            />
            <Action
              id={ACTION_EDIT}
              label={'Edit'}
              icon={<EditIcon />}
              onClick={onEdit}
              disabled={!isActionAllowed(ACTION_EDIT)}
            />
            <Action
              id={ACTION_DELETE}
              label={'Delete'}
              icon={<DeleteIcon />}
              onClick={onDelete}
              disabled={!isActionAllowed(ACTION_DELETE)}
            />
          </UIActions>
        );
      }}
    </Permissions>
  );
};
